import { useRef } from 'react';
import { useIsomorphicLayoutEffect } from './use-isomorphic-layout-effect';
export const useLatestValue = value => {
  const cache = useRef(value);
  useIsomorphicLayoutEffect(() => {
    cache.current = value;
  }, [value]);
  return cache;
};